import Apuracao from './ApuracaoController';

export default Apuracao;
